import React, { Component } from 'react'
import PropTypes from 'prop-types'

import SidePanel from './SidePanel'
import Logo from './SidePanel/logo.js'

class ResetPasswordSuccess extends Component {
  static propTypes = {
    history: PropTypes.object,

    // true if the user is invited to set password & join the platform
    setPassword: PropTypes.bool
  }

  render () {
    return (
      <div className='auth'>
        <SidePanel />
        <div className='expert-form-login'>
          <Logo className='auth-form-logo' />
          <div className='expert-form-login__title'>
            {this.props.setPassword ? 'Password set' : 'Reset password'}
          </div>
          <div className='expert-form__label--black'>
            Your new password has been saved, you can log in now.
          </div>
          <div
            className='link m-t-md'
            onClick={() => this.props.history.push('/auth/login')}
          >
            Back to login
          </div>
        </div>
      </div>
    )
  }
}

export default ResetPasswordSuccess
